import { salesOrdersTypes } from './actionTypes';

const INIT_STATE = {
  salesOrdersData: [],
  milestoneConfig: [],
  CountItems: 0,
  isLoading: false,
  error: {},
};

const salesOrders = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case salesOrdersTypes.GET_ORDERS_DEFINITIONS:
      return {
        ...state,
        isLoading: true,
      };
    case salesOrdersTypes.GET_SALE_ORDERS_SUCCESS:
      return {
        ...state,
        salesOrdersData: action.payload.salesOrdersData,
        CountItems: action.payload.CountItems,
        isLoading: false,
      };

    case salesOrdersTypes.GET_SALE_ORDERS_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case salesOrdersTypes.GET_MILESTONESCONFIG_SO_SUCCESSS:
        return{
          ...state,
          milestoneConfig: action.payload
        }
  
    case salesOrdersTypes.GET_MILESTONESCONFIG_SO_FAIL:
          return{
            ...state,
            error: action.payload,
          }

    default:
      return state;
  }
};

export default salesOrders;
